<template>
  <div style="margin-top: 0; margin-left: 0">
    <div
      style="
        width: 465px;
        margin-bottom: 20px;
        margin-top: 25px;
        position: relative;
      "
      class="lk_content_info_block"
    >
      <div style="display: table-cell; width: 70px">
        <el-icon
          style="
            font-size: 50px;
            position: absolute;
            transform: rotate(180deg);
            left: 20px;
            color: #e82862;
          "
          ><Warning
        /></el-icon>
      </div>
      <div style="display: table-cell">
        <br />
        <span v-if="store.langSelect.value == 0">
          Перевод осуществляется только между собственными счетами
        </span>
        <span v-else>Transfers are made only between own accounts</span>
        <br /><br />
      </div>
    </div>
    <div v-if="!requestSended">
      <div class="myselector" style="width: 507px">
        <el-select
          v-model="selectedaccount"
          icon-сlass="caret-top"
          :placeholder="messages.withdrawalSel[store.langSelect.value]"
        >
          <el-option
            v-for="(item, i) in accounts.sort((a, b) =>
              a.Account > b.Account ? 1 : b.Account > a.Account ? -1 : 0
            )"
            :key="i"
            :label="item.Account"
            :value="item.Account"
          >
          </el-option>
        </el-select>
        <span v-if="selectedaccount" style="margin-left: 20px; font-size: 80% ; " >
          Money free: {{ getMoneyFree(selectedaccount) }}</span
        >
      </div>
      <div v-if="selectedaccount " style="margin-top: 20px">
        <div style="margin-top: 20px; width: 507px">
          <el-select
            v-model="selectedCurrency"
            value-key="Ticker"
            placeholder="Select"
          >
            <el-option
              v-for="(item, i) in currency_info.sort((a, b) =>
                a.Ticker > b.Ticker ? 1 : b.Ticker > a.Ticker ? -1 : 0
              )"
              :key="i"
              :label="item.Ticker"
              :value="item"
            >
            </el-option>
          </el-select>
          <span
            v-if="selectedCurrency"
            style="margin-left: 20px; font-size: 80%"
          >
            Shares: {{ selectedCurrency.Shares }}</span
          >
          <div v-show="selectedaccount" style="margin-top: 20px">
            <div class="myselector" style="width: 507px">
              <el-select
                v-model="outAccount"
                icon-сlass="caret-top"
                :placeholder="messages.withdrawalSel[store.langSelect.value]"
              >
                <el-option
                  v-for="(item, i) in accounts.sort((a, b) =>
                    a.Account > b.Account ? 1 : b.Account > a.Account ? -1 : 0
                  )"
                  :key="i"
                  :label="item.Account"
                  :value="item.Account"
                >
                </el-option>
              </el-select>
              <span
                v-if="outCurrency !== ''"
                style="margin-left: 20px; font-size: 80%"
              >
                {{ selectedCurrency.Ticker }} :
              </span>
              <span v-if="outCurrency != undefined" style="font-size: 80%">
                {{ outCurrency.Shares }}
              </span>
            </div>
            <div v-show="outAccount">
              <el-input-number
                v-model="volume"
                :min="0"
                :max="valueMax"
                class="elintutcolor"
                style="width: 200px; margin: 20px 0"
                size="small"
                controls-position="right"
                @change="handleVolumeChange"
              >
              </el-input-number>
            </div>
            <div v-show="volume > 0">
              <Button
                :text="messages.withdrawalB[store.langSelect.value]"
                @click="sendRequest"
              />
            </div>
          </div>
        </div>
      </div>
    <!--  <div v-else><span v-show="selectedaccount" style="margin: 20px 0 0 20px; font-size: 80% ; color: red"> USDT: {{ usdtAcc }}</span></div> -->
      <div style="margin-top: 20px"></div>
    </div>
    <div v-else>
      <h3>{{ messages.withdrawalSent[store.langSelect.value] }}</h3>
    </div>
  </div>
  <CheckCode
    :show="ShowCheck"
    :checkedfn="sendRequest"
    @closedialog="CloseCodeDialog"
  ></CheckCode>
  <ServiceHistoryTable>
    <template v-slot:mtthead="">
      <div class="th">Date</div>
      <div class="th">Account</div>
      <div class="th">Ticker</div>
      <div class="th">Volume</div>
      <div class="th">To account</div>
    </template>
    <template v-slot:mttbody="props">
      <div class="tr" v-show="props.item.Service == 'transfer'">
        <div class="td">{{ getStringTime(props.item.Date) }}</div>
        <div class="td">{{ props.item.HistoryInfo.InAccount }}</div>
        <div class="td">{{ props.item.HistoryInfo.Ticker }}</div>
        <div class="td">{{ props.item.HistoryInfo.Volume }}</div>
        <div class="td">{{ props.item.HistoryInfo.OutAccount }}</div>
      </div>
    </template>
  </ServiceHistoryTable>
</template>

<script>
import { useMyStorage, getAccPositions } from "@/store/global";
import { ref, watch } from "vue";
//import MoneyTransactionHistoryTable from "./MoneyTransactionHistoryTable";
import Button from "@/components/Button";
import CheckCode from "@/components/CheckCode";
import axios from "axios";
import { Warning } from "@element-plus/icons-vue";
import ServiceHistoryTable from "./ServiceHistotyTable";

export default {
  name: "TransferComponent",
  components: {
    Button,
    CheckCode,
    Warning,
    ServiceHistoryTable,
  },
  setup() {
    const store = useMyStorage();
    const ShowCheck = ref(false);
    const accounts = store.userInfo.value.Info.Accounts;
    const selectedaccount = ref("");
    const outAccount = ref("");
    const currency_info = ref({});
    const selectedCurrency = ref("");
    const outCurrency = ref("");
    const valueMax = ref(0.0);
    const requestSended = ref(false);
    const volume = ref(0);
    const usdtAcc= ref(undefined)

    let positions_info = getAccPositions(selectedaccount.value);

    const getCurrencyInfo = () => {
      currency_info.value = {};
      selectedCurrency.value = "";

      let res = positions_info.value.filter(
        (item) =>
          item.Ticker.length < 5 &&
          (item.Ticker === "USDT" ||
            item.Ticker === "BTC" ||
            item.Ticker === "AE")
      );
      currency_info.value = res;
      if (currency_info.value) {
        selectedCurrency.value = currency_info.value[0];
      }
    };
    watch(
      () => selectedaccount.value,
      (val) => {
        positions_info = getAccPositions(val);
        usdtAcc.value=store.CheckPosition(val, "USDT")
        getCurrencyInfo();
      }
    );
    watch(
      () => selectedCurrency.value,
      () => {
        outCurrency.value = undefined;
        outAccount.value = undefined;
        volume.value = 0;
        valueMax.value = 0;
      }
    );
    watch(
      () => outAccount.value,
      (val) => {
        if (val === undefined) {
          return;
        }
        if (val === selectedaccount.value) {
          outAccount.value = undefined;
          outCurrency.value = undefined;
          valueMax.value = 0;
          volume.value = 0;
          return;
        }
        let pos = getAccPositions(val);
        console.log(pos);
        console.log(selectedCurrency.value.Ticker);
        outCurrency.value = pos.value.filter(
          (item) => item.Ticker === selectedCurrency.value.Ticker
        )[0];
        let max =
          getMoneyFree(selectedaccount.value) /
          store.Instruments[selectedCurrency.value.Ticker].Last;
        if (max && max < selectedCurrency.value.Shares) {
          valueMax.value = max;
        } else {
          valueMax.value = selectedCurrency.value.Shares;
        }
        if(selectedCurrency.value.Ticker==="AE"){
          valueMax.value = selectedCurrency.value.Shares;
        }
        console.log(outCurrency.value);
      }
    );
    const getMoneyFree = (acc) => {
      let inf = store.getAccountInfo(acc);
      console.log(inf);
      return inf.value.MoneyFree;
    };
    const handleVolumeChange = (v) => {
      console.log(v);
      volume.value = v * 1;
    };
    const CloseCodeDialog = () => {
      // console.log("emit")
      ShowCheck.value = false;
    };
    const CheckCode = () => {
      //   console.log(ShowCheck.value)
      ShowCheck.value = true;
    };
    const getStringTime = (dt) => {
      const ts= new Date(dt)
      // console.log(val)
       console.log("++++++++++"+ts+"----------")

        return (
          ts.getUTCFullYear() +
          "-" +
          pad(ts.getUTCMonth() + 1) +
          "-" +
          pad(ts.getUTCDate()) +
          " " +
          pad(ts.getUTCHours()) +
          ":" +
          pad(ts.getUTCMinutes()) +
          ":" +
          pad(ts.getUTCSeconds())
        );
    };
    const pad = (n) => {
      return n < 10 ? "0" + n : n;
    };

    const sendRequest = () => {
      //  let token = store.token.value;
      const data = {
        InAccount: selectedaccount.value.trim(),
        OutAccount: outAccount.value.trim(),
        Ticker: selectedCurrency.value.Ticker,
        Volume: volume.value.toString(),
      };
      // console.log(token);
      //     axios.defaults.headers.common["Authorization"] = token;
      axios.post(store.ServerUrl + "/users/transfer", data);
      let shis = {
        service: "transfer",
        accounts: data.InAccount,
        email: store.userInfo.value.Roles.email,
        status: "pending",
        historyinfo: JSON.stringify(data),
      };
      axios
        .post(store.ServerUrl + "/users/savesevicehistory", shis)
        .finally(() => {
          store.LoadAllHistory();
        });
      requestSended.value = true;
      store.LoadAllHistory();
    };
    store.LoadAllHistory();
    return {
      store,
      usdtAcc,
      sendRequest,
      requestSended,
      positions_info,
      accounts,
      currency_info,
      selectedaccount,
      selectedCurrency,
      ShowCheck,
      CheckCode,
      CloseCodeDialog,
      getStringTime,
      getMoneyFree,
      outAccount,
      outCurrency,
      handleVolumeChange,
      valueMax,
      volume,
      messages: {
        withdrawalH: ["Заявка на вывод средств", "Withdrawal request"],
        withdrawalSel: ["Выберите счет", "Select account"],
        withdrawalSum: ["Сумма перевода", "Transfer amount"],
        withdrawalAddr: ["Адрес", "Address"],
        withdrawalB: ["Отправить", "Send"],
        withdrawalSent: [
          "Ваш запрос отправлен.",
          "Your request has been sent.",
        ],
        withdrawalFor: [
          {
            USDT: "Вывод USDT только TRC20 сети Tron <br>Минимальная сумма вывода 10 USDT<br> Комиссия сети 3 USDT",
            BTC: "Минимальная сумма вывода 0.0001 BTC <br> Комиссия сети 0.0001 - 0.00077",
            AE: "",
          },
          {
            USDT: "USDT Withdrawal Only TRC20 Tron Network<br>Minimum withdrawal amount 10 USDT<br>Network fee 3 USDT",
            BTC: "Minimum withdrawal amount 0.0001 BTC<br>Network commission 0.0001 - 0.00077",
            AE: "",
          },
        ],
        withdrawalAE: [
          "Вывод токена АЕ временно не производится",
          "The withdrawal of the AE token is temporarily not available",
        ],
      },
    };
  },
};
</script>

<style scoped></style>
